import QuestionStatus from 'components/CleanRooms/CurrentQuestions/QuestionStatus';
import React, { memo, useContext } from 'react';
import { DataContext } from 'BaseComponents/HDataTable/DataContextProvider';
import { usePublishQuestion, useUnpublishQuestion } from 'hooks/questionAPIs';


export const PublishStatusCell = memo(({ row }) => {
  const {
    refreshListData,
  } = useContext(DataContext);

  const {
    mutateAsync: publishQuestion,
  } = usePublishQuestion();

  const {
    mutateAsync: unpublishQuestion,
  } = useUnpublishQuestion();

  const handlePublish = async (questionId) => {
    await publishQuestion({ questionId });
    refreshListData();
  };

  const handleUnpublish = async (questionId) => {
    await unpublishQuestion({ questionId });
    refreshListData();
  };

  return (
    <QuestionStatus
      question={row}
      handlePublish={handlePublish}
      handleUnpublish={handleUnpublish}
    />
  );
});

PublishStatusCell.displayName = 'PublishStatusCell';
